module.exports = __webpack_public_path__ + "img/artwork-4.7f8c9999.png";